import { render, staticRenderFns } from "./GamePopUp.vue?vue&type=template&id=1455f73f&scoped=true"
import script from "./GamePopUp.vue?vue&type=script&lang=js"
export * from "./GamePopUp.vue?vue&type=script&lang=js"
import style0 from "./GamePopUp.vue?vue&type=style&index=0&id=1455f73f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455f73f",
  null
  
)

export default component.exports